function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

const _ = require('lodash');

function _call(body, then, direct) {
  if (direct) {
    return then ? then(body()) : body();
  }

  try {
    var result = Promise.resolve(body());
    return then ? result.then(then) : result;
  } catch (e) {
    return Promise.reject(e);
  }
}

const AccessContext = require('./contexts/access-context');

function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }

    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}

const Business = require('../entities/business');

const PagedList = require('../entities/paged-list');

const UsersRepo = require('./users-repo');

const OffersRepo = require('./offers-repo');

const LocationsRepo = require('./locations-repo');

const BusinessRepoHelper = require('./business-repo-helper');

const TagsRepo = require('./tags-repo');

const AppsRepo = require('./apps-repo');

const BusinessCategoriesRepo = require('./business-categories-repo');

const businessUpdatePipeline = require('./business-update-pipeline');

const StatsRepo = require('./stats-repo');

const ImageLinksRepo = require('./image-links-repo');

const Plan = require('../entities/plan');

const BusinessLocalizationDictionary = require('../entities/business-localization-dictionary');

const getPropertyLocales = require('../utils/get-property-locales');

const {
  poll
} = require('../utils/poll');

const BusinessLocalizerFactory = require('../entities/business-localizer');

const {
  strList,
  strinct,
  nullable
} = require('../utils/serialize');

const {
  serializeImages,
  findImage
} = require('../utils/entities');

const IntegrationsRepo = require('./integrations-repo');

const DestinationsRepo = require('./destinations-repo');

const HmacsRepo = require('./hmacs-repo');

const SocialRepo = require('./social/social-repo');

const watchTask = require('../utils/task');

const TYPE_NAME = TagsRepo.TYPE_NAMES.business;
const fields = ['id', 'name', 'slug', 'shortName', 'slogan', 'desc', 'images', 'phone', 'url', 'socialProfiles'];
const rawListFields = fields.filter(f => f !== 'slug');
const searchFields = ['id', 'name', 'shortName', 'slogan', 'desc', 'isEnabled', 'images', 'categories(id,name)', 'tags(name)', 'phone', 'url'];
const singleSearchFields = ['id', 'name', 'shortName', 'slogan', 'desc', 'isEnabled', 'images', 'categories(id,name)', 'tags(name)', 'phone', 'url', 'localizations(content,locale)', 'socialProfiles', 'profileImages.url'];
/*:: type ISODateString = string;*/

/*:: type limitSchedule = {
  startDate: ISODateString,
  endDate: ISODateString,
  weekdays: [number]
};*/

function parse(json)
/*: Business*/
{
  const hasPlanInfo = json.policies && json.policies[0] && json.policies[0].plan;
  return new Business({
    id: json.id,
    name: json.name,
    slug: json.slug,
    shortName: json.shortName,
    slogan: json.slogan,
    description: json.desc,
    url: json.url,
    phone: json.phone,
    profileImage: findImage(json.images, 'business-profile'),
    logoImage: findImage(json.images, 'business-logo-standard'),
    heroImage: findImage(json.images, 'business-hero-standard'),
    isEnabled: json.isEnabled,
    categories: json.categories,
    tags: json.tags,
    localizations: json.localizations,
    locations: json.locations ? json.locations : null,
    plan: hasPlanInfo ? json.policies[0].plan : null,
    socialProfiles: json.socialProfiles,
    meta: json.meta,
    generatedContextStatus: json.generatedContextStatus,
    profileImages: json.profileImages && json.profileImages.map(i => i.url)
  });
}

function serialize(data)
/*: Object*/
{
  const socialProfiles = data.socialProfiles ? data.socialProfiles.filter(p => !!p.id) : data.socialProfiles;
  return {
    name: data.name,
    shortName: data.shortName,
    desc: strinct(data.description),
    images: serializeImages([data.profileImage, data.logoImage, data.heroImage]),
    // TODO: Why are there fields that can come from the API as null but can't be set as null?
    slogan: strinct(data.slogan),
    url: nullable(strinct)(data.url),
    phone: strinct(data.phone),
    socialProfiles
  };
}

class BusinessRepo {
  constructor(client
  /*: ApiClient*/
  , id
  /*: businessId*/
  , parentContext
  /*: AccessContext*/
  = new AccessContext(null)) {
    this.id = id;
    this.context = parentContext.clone({
      business: id
    });
    this.client = client;
    this.users = new UsersRepo(client, this.context);
    this.offers = new OffersRepo(client, this.context);
    this.locations = new LocationsRepo(client, this.context);
    this.categories = new BusinessCategoriesRepo(client, this.context);
    this.stats = new StatsRepo(client, this.context);
    this.images = new ImageLinksRepo(client, this.context);
    this.apps = new AppsRepo(client, this.context);
    this.integrations = new IntegrationsRepo(client, this.context);
    this.destinations = new DestinationsRepo(client, this.context);
    this.hmacs = new HmacsRepo(client, this.context);
    this.social = new SocialRepo(client, this.context);
  }

  details()
  /*: Promise<Business>*/
  {
    const _this = this;

    return _call(function () {
      return _await(_this.coreDetails(), function (business) {
        const helper = new BusinessRepoHelper(_this.client, _this.context);
        return helper.getBusinessCategoriesStep(business);
      });
    });
  } // FIXME: Remove when this call isn't used anywhere


  detailsForAdmin()
  /*: Promise<Business>*/
  {
    return this.details();
  }

  waitForIndex(compareFn
  /*: Function*/
  , onTimeout
  /*: Function*/
  )
  /*: Promise<boolean>*/
  {
    const _this2 = this;

    return _call(function () {
      const {
        propertyId,
        businessId
      } = _this2.context.serialize();

      const path = `/properties/${propertyId}/businesses/search`;
      const params = {
        businessId
      };
      const req = new _this2.client.Request(path, params, searchFields);

      const predicate = _async(function ()
      /*: Promise<boolean>*/
      {
        return _await(_this2.client.get(req), function (result) {
          return result.items.length ? compareFn ? compareFn(result.items[0]) : true : false;
        });
      });

      return _await(poll(predicate, 1000, 5000).catch(err => {
        if (!err.isTimeout) throw err;
        /* eslint-disable-next-line no-console */

        console.error(new Error('Waiting for business for more than 5 seconds...'));
        return poll(predicate, 1000, 55000, onTimeout);
      }).catch(err => {
        if (!err.isTimeout) throw err;
        throw new Error('Business not found');
      }));
    });
  }

  coreDetails(nothing
  /*: undefined*/
  , options
  /*: RequestOptions*/
  = {})
  /*: Promise<Business>*/
  {
    const _this3 = this;

    return _call(function () {
      const {
        propertyId,
        businessId
      } = _this3.context.serialize();

      if (propertyId) {
        const path = `/properties/${propertyId}/businesses/search`;
        const params = {
          businessId
        };
        const req = new _this3.client.Request(path, params, options.fields || singleSearchFields);
        req.parse = parse;
        return _await(_this3.client.get(req).then(({
          items
        }) => items[0]).then(_this3.client.enrichment.readTap(_this3.context.serialize(), _this3.client.enrichment.applyAll)));
      }

      const path = `/businesses/${businessId}`;
      const req = new _this3.client.Request(path, {}, options.fields || fields);
      req.parse = parse;
      return _await(_this3.client.get(req));
    });
  }

  enable(plan
  /*: Plan*/
  )
  /*: Promise<any>*/
  {
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    if (!propertyId) throw new Error('Cannot enable business without property'); // FIXME: Looks for existing Policy to determine whether to enable or link, which is ridiculous

    return this.client.policy.find(propertyId, businessId).then(policy => {
      if (!policy) return this.client.policy.link(propertyId, businessId, plan.id);
      return this.client.policy.enable(propertyId, businessId);
    }).then(this.client.enrichment.writeTap(this.context.serialize(), () => ({
      isEnabled: true
    })));
  }

  disable()
  /*: Promise<any>*/
  {
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    if (!propertyId) throw new Error('Cannot disable business without property');
    if (!businessId) throw new Error('Cannot disable business without business');
    return this.client.policy.disable(propertyId, businessId).then(this.client.enrichment.writeTap(this.context.serialize(), () => ({
      isEnabled: false
    })));
  } // TODO: This needs to be re-worked to better take advantage of the known context...


  update(inst
  /*: Business*/
  , updates
  /*: Business | Object*/
  ) {
    return businessUpdatePipeline(this.context, this.client, inst, updates, parse, serialize, fields);
  }

  editWithLocalization()
  /*: Promise<Business>*/
  {
    const _this4 = this;

    return _call(function () {
      return _await(Promise.all([_this4.details(), _this4.getLocalizations().then(r => r.items), getPropertyLocales(_this4)]), function ([business, localizations, locales]) {
        return BusinessLocalizerFactory(locales).setLocalizations(business, localizations);
      });
    });
  }

  updatePlan(planId
  /*: string*/
  )
  /*: Promise<boolean>*/
  {
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    const updates = {
      planId
    };
    return this.client.policy.find(propertyId, businessId).then(policy => this.client.policy.update(propertyId, policy.id, updates));
  }

  getPlan()
  /*: Promise<?Plan>*/
  {
    const _this5 = this;

    return _call(function () {
      const {
        propertyId,
        businessId
      } = _this5.context.serialize();

      return _await(_this5.client.properties.for(propertyId).plans.getBusinessPlan(businessId).catch(err => {
        // Return null _if_ the plan cannot be found.
        if (err.status === 404) return null;
        return Promise.reject(err);
      }));
    });
  }

  checkLimits({
    /*: {
        offerId?: string,
        visibleSchedules?: [limitSchedule],
        usableSchedules?: [limitSchedule],
        discoverableSchedules?: [limitSchedule],
        locationIds?: [string]
      }*/

    offerId,
    visibleSchedules,
    usableSchedules,
    discoverableSchedules,
    locationIds
  })
  /*: (Promise<any>)*/
  {
    const _this6 = this;

    return _call(function () {
      const limitFields = [];

      const {
        propertyId,
        businessId
      } = _this6.context.serialize();

      const path = `/properties/${propertyId}/businesses/${businessId}/limits/check`;
      const params = {
        offerId,
        visibleSchedules,
        usableSchedules,
        discoverableSchedules,
        locationIds
      };
      const req = new _this6.client.Request(path, params, limitFields);
      return _await(_this6.client.post(req), function (response) {
        if (response.success) return true;
        const err = new Error('Plan Limits Exceeded');
        err.planLimitViolations = response.violations;
        err.context = {
          propertyId,
          businessId,
          offerId
        };
        throw err;
      });
    });
  }

  delete()
  /*: (Promise<boolean>)*/
  {
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    const url = propertyId ? `/properties/${propertyId}/businesses/${businessId}` : `/businesses/${businessId}`;
    return this.client.delete(new this.client.Request(url));
  }

  getTags()
  /*: (Promise<any>)*/
  {
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    return this.client.tags.list(propertyId, TYPE_NAME, businessId);
  }

  updateTags(newTags
  /*: Array<string>*/
  )
  /*: (Promise<any>)*/
  {
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    return this.client.tags.reconcile(propertyId, TYPE_NAME, businessId, newTags);
  }

  addTag(tagName
  /*: string*/
  )
  /*: (Promise<any>)*/
  {
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    return this.client.tags.create(propertyId, TYPE_NAME, businessId, tagName).then(() => true).catch(() => false);
  }

  removeTag(tagName
  /*: string*/
  )
  /*: (Promise<any>)*/
  {
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    return this.client.tags.delete(propertyId, TYPE_NAME, businessId, tagName).then(() => true).catch(() => false);
  }

  updateSlug(newSlug
  /*: string*/
  )
  /*: Promise<string>*/
  {
    const {
      businessId
    } = this.context.serialize();
    const path = `/businesses/${businessId}/slugs`;
    const req = new this.client.Request(path, {
      inputString: newSlug
    }, ['slug']);
    return this.client.post(req).then(({
      slug
    }) => slug);
  }

  claim({
    userId,
    skipReferralContextAttribution
  } = {})
  /*: Promise<boolean>*/
  {
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    const path = propertyId ? `/businesses/${businessId}/properties/${propertyId}/claim` // Yes this is on purpose
    : `/businesses/${businessId}/claim`;
    const req = new this.client.Request(path, {
      userId,
      skipReferralContextAttribution
    });
    return this.client.post(req);
  }

  autoLink()
  /*: Promise<Boolean>*/
  {
    // Automatically create/update policy in property
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    if (!propertyId) throw new Error('Missing required propertyId');
    if (!businessId) throw new Error('Missing required businessId');
    const path = `/properties/${propertyId}/businesses/${businessId}/policy`;
    const req = new this.client.Request(path);
    return this.client.post(req);
  }

  getLocalizations()
  /*: Promise<PagedList<any>>*/
  {
    const ALL_LOCALE_FIELDS = ['id', 'type', 'modelId', 'locale', 'content', 'priority'];
    const {
      businessId
    } = this.context.serialize();
    const path = `/businesses/${businessId}/localizations`;
    const req = new this.client.Request(path, {}, ALL_LOCALE_FIELDS);
    req.parse = BusinessLocalizationDictionary.fromJson;
    return this.client.get(req);
  }

  setLocalization({
    locale,
    content
  })
  /*: Promise<any>*/
  {
    const setFields = ['id'];
    const {
      businessId
    } = this.context.serialize();
    const path = `/businesses/${businessId}/localizations`;
    const params = {
      locale,
      content
    };
    const req = new this.client.Request(path, params, setFields);
    req.serialize = BusinessLocalizationDictionary.serialize;
    return this.client.post(req);
  }

  getValidations()
  /*: Promise<any>*/
  {
    const getFields = [];
    const {
      businessId
    } = this.context.serialize();
    const path = `/businesses/${businessId}/validation`;
    const req = new this.client.Request(path, {}, getFields);
    return this.client.get(req);
  }

  initializeBillingAddress({
    firstName,
    lastName,
    line1,
    city,
    stateCode,
    zip,
    country,
    company
  })
  /*: Promise<any>*/
  {
    if (country.length !== 2) throw new Error('Country must be 2-letter country code');
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    const path = `/properties/${propertyId}/businesses/${businessId}/chargebee/billingAddress/initialize`;
    const params = {
      data: {
        line1,
        city,
        state_code: stateCode,
        zip,
        country,
        company,
        first_name: firstName,
        last_name: lastName
      }
    };
    const req = new this.client.Request(path, params, ['city']);
    return this.client.post(req);
  }

  initializeCustomer({
    createdByEmail,
    hubspotCompanyId,
    hubspotDealId,
    company,
    email
  })
  /*: Promise<any>*/
  {
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    const path = `/properties/${propertyId}/businesses/${businessId}/chargebee/customer/initialize`;
    const params = {
      data: {
        cf_created_by_email: createdByEmail,
        cf_hubspot_company_id: hubspotCompanyId,
        cf_hubspot_deal_id: hubspotDealId,
        company,
        email
      }
    };
    const req = new this.client.Request(path, params, ['id']);
    return this.client.post(req);
  } // Create a signed Chargebee checkout URL which can be opened in a browser or passed to the Chargebee widget


  checkout({
    /*: { itemPriceId: string }*/

    itemPriceId
  })
  /*: Promise<string>*/
  {
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    const path = `/properties/${propertyId}/businesses/${businessId}/chargebee/checkout`;
    const params = {
      itemPriceId
    };
    const req = new this.client.Request(path, params, ['url']);
    return this.client.post(req);
  } // Create a signed Chargebee portal session URL which can be opened in a browser or passed to the Chargebee widget


  getPortalSession()
  /*: Promise<string>*/
  {
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    const path = `/properties/${propertyId}/businesses/${businessId}/chargebee/portal/session`;
    const req = new this.client.Request(path, {}, ['token']);
    return this.client.post(req);
  } // Directly create a new Chargebee Subscription for the Business without user intervention
  // This is a strictly limited route only intended to be used by internal employees.


  createSubscription({
    /*: {
        planItemPriceId: string,
        planUnitPrice: number,
        onboardingUnitPrice: number,
        autoCollection: ['on', 'off'],
        couponIds: Array<string>,
        freePeriod: number,
        freePeriodUnit: ['day', 'week', 'month', 'year'],
      }*/

    planItemPriceId,
    planUnitPrice,
    onboardingUnitPrice,
    autoCollection,
    couponIds,
    freePeriod,
    freePeriodUnit
  })
  /*: Promise<any>*/
  {
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    const path = `/properties/${propertyId}/businesses/${businessId}/chargebee/subscription`;
    const params = {
      planItemPriceId,
      planUnitPrice,
      onboardingUnitPrice,
      autoCollection,
      couponIds,
      freePeriod,
      freePeriodUnit
    };
    const req = new this.client.Request(path, params);
    return this.client.post(req);
  }

  createPaymentUrl()
  /*: Promise<string>*/
  {
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    const path = `/properties/${propertyId}/businesses/${businessId}/chargebee/paymentUrl`;
    const req = new this.client.Request(path, {}, ['url']);
    return this.client.post(req);
  }

  getBillingAddress()
  /*: Promise<string>*/
  {
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    const getFields = ['line1', 'line2', 'line3', 'city', 'state_code', 'state', 'country', 'zip'];
    const path = `/properties/${propertyId}/businesses/${businessId}/chargebee/billingAddress`;
    const req = new this.client.Request(path, {}, getFields);
    return this.client.get(req);
  }

  getBillingDetails()
  /*: Promise<object>*/
  {
    const getFields = ['billingAddress.firstName', 'billingAddress.lastName', 'billingAddress.email', 'billingAddress.company', 'billingAddress.line1', 'billingAddress.line2', 'billingAddress.line3', 'billingAddress.city', 'billingAddress.stateCode', 'billingAddress.state', 'billingAddress.country', 'billingAddress.zip', 'subscription.billingPeriod', 'subscription.billingPeriodUnit', 'subscription.currencyCode', 'subscription.itemPriceId', 'subscription.nextBillingAt', 'subscription.currentTermStart', 'subscription.currentTermEnd', 'subscription.price'];
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    const path = `/properties/${propertyId}/businesses/${businessId}/chargebee/details`;
    const req = new this.client.Request(path, {}, getFields);
    return this.client.get(req);
  }

  runOfferSuggestionTask()
  /*: Promise<any>*/
  {
    const {
      businessId
    } = this.context.serialize();
    const path = `/businesses/${businessId}/suggestions/tasks`;
    const req = new this.client.Request(path, {
      type: 'suggest-business-offers'
    }, ['id']);
    return this.client.post(req);
  } // eslint-disable-next-line no-underscore-dangle


  _getOfferSuggestionTask(id
  /*: string*/
  )
  /*: Promise<any>*/
  {
    const {
      businessId
    } = this.context.serialize();
    const path = `/businesses/${businessId}/suggestions/tasks/${id}`;
    const taskFields = ['id', 'output', 'status', 'type', 'input', 'updated', 'created'];
    const req = new this.client.Request(path, {}, taskFields);
    return this.client.get(req);
  }

  awaitOfferSuggestionTask(taskId
  /*: string*/
  , onProgress
  /*: (any) => void*/
  )
  /*: Promise<any>*/
  {
    const _this7 = this;

    return _call(function () {
      return _await(watchTask(taskId, // eslint-disable-next-line no-underscore-dangle
      id => _this7._getOfferSuggestionTask(id), {
        onProgress,
        timeout: 60000
      }));
    });
  }

  runOfferRewriteTask({
    headline,
    subhead,
    details
  })
  /*: Promise<any>*/
  {
    const {
      businessId
    } = this.context.serialize();
    const path = `/businesses/${businessId}/suggestions/tasks`;
    const req = new this.client.Request(path, {
      type: 'refresh-offer',
      input: {
        headline,
        subhead,
        details
      }
    }, ['id']);
    return this.client.post(req);
  } // eslint-disable-next-line no-underscore-dangle


  _getOfferRewriteTask(id
  /*: string*/
  )
  /*: Promise<any>*/
  {
    const {
      businessId
    } = this.context.serialize();
    const path = `/businesses/${businessId}/suggestions/tasks/${id}`;
    const taskFields = ['id', 'output', 'status', 'type', 'input', 'updated', 'created'];
    const req = new this.client.Request(path, {}, taskFields);
    return this.client.get(req);
  }

  awaitOfferRewriteTask(taskId
  /*: string*/
  , onProgress
  /*: (any) => void*/
  )
  /*: Promise<any>*/
  {
    const _this8 = this;

    return _call(function () {
      return _await(watchTask(taskId, // eslint-disable-next-line no-underscore-dangle
      id => _this8._getOfferSuggestionTask(id), {
        onProgress,
        timeout: 60000
      }));
    });
  }

  runCrawlTask()
  /*: Promise<any>*/
  {
    const {
      businessId
    } = this.context.serialize();
    const path = `/businesses/${businessId}/crawl/tasks`;
    const body = {
      type: 'crawl',
      input: {}
    };
    const req = new this.client.Request(path, body, ['id']);
    return this.client.post(req);
  } // eslint-disable-next-line no-underscore-dangle


  _getCrawlTask(id
  /*: string*/
  )
  /*: Promise<any>*/
  {
    const {
      businessId
    } = this.context.serialize();
    const path = `/businesses/${businessId}/crawl/tasks/${id}`;
    const taskFields = ['id', 'output', 'status', 'type', 'input', 'updated', 'created'];
    const req = new this.client.Request(path, {}, taskFields);
    return this.client.get(req);
  }

  awaitCrawlTask(taskId
  /*: string*/
  , onProgress
  /*: (any) => void*/
  )
  /*: Promise<any>*/
  {
    const _this9 = this;

    return _call(function () {
      return _await(watchTask(taskId, // eslint-disable-next-line no-underscore-dangle
      id => _this9._getCrawlTask(id), {
        onProgress,
        timeout: 180000
      }));
    });
  }

  runSummarizeTask(crawlTaskId)
  /*: Promise<any>*/
  {
    const {
      businessId
    } = this.context.serialize();
    const path = `/businesses/${businessId}/crawl/tasks`;
    const body = {
      type: 'summarize',
      input: {
        crawlTaskId
      }
    };
    const req = new this.client.Request(path, body, ['id']);
    return this.client.post(req);
  } // eslint-disable-next-line no-underscore-dangle


  _getSummarizeTask(id
  /*: string*/
  )
  /*: Promise<any>*/
  {
    const {
      businessId
    } = this.context.serialize();
    const path = `/businesses/${businessId}/crawl/tasks/${id}`;
    const taskFields = ['id', 'output', 'status', 'type', 'input', 'updated', 'created'];
    const req = new this.client.Request(path, {}, taskFields);
    return this.client.get(req);
  }

  awaitSummarizeTask(taskId
  /*: string*/
  , onProgress
  /*: (any) => void*/
  )
  /*: Promise<any>*/
  {
    const _this10 = this;

    return _call(function () {
      return _await(watchTask(taskId, // eslint-disable-next-line no-underscore-dangle
      id => _this10._getSummarizeTask(id), {
        onProgress,
        timeout: 180000
      }));
    });
  }

}

class BusinessesRepo {
  constructor(client
  /*: ApiClient*/
  , parentContext
  /*: AccessContext*/
  = new AccessContext(null)) {
    this.client = client;
    this.context = parentContext;
    this.apps = new AppsRepo(client, parentContext);

    this.for = (id
    /*: businessId*/
    ) => new BusinessRepo(client, id, this.context);

    this.icanhas = this.for;
  }

  listNotAttached({
    /*: {
        query: string
      }*/

    query
  } = {})
  /*: (Promise<PagedList<Business>>)*/
  {
    const {
      propertyId
    } = this.context.serialize();
    const path = `/properties/${propertyId}/businesses/discovery/search`;
    const params = {
      q: strinct(query)
    };
    const discoveryFields = ['id', 'name', 'categories.name', 'profileImages.url'];
    const req = new this.client.Request(path, params, discoveryFields);
    req.parse = parse;
    return this.client.get(req);
  }
  /**
   * Fetch a list of businesses
   *
   * @async
   * @param {Object} params
   * @param {Object} options - standard options for requests
   * @return {Promise<PagedList<Business>>}
   */


  list({
    /*: {
        query: string,
        enabled: boolean,
        tags: ?Array<string>,
        businessId: string,
        planIds: ?Array<string>,
        limit: ?number,
        fetchPlan: boolean,
        fetchLocations: boolean,
        hasRoles: boolean,
        hasLocations: boolean,
        locationsHasLiveOffers: boolean,
        locationsEnabled: boolean
      }*/

    query,
    enabled,
    tags,
    businessId,
    planIds,
    limit,
    fetchPlan,
    fetchLocations,
    hasRoles,
    hasLocations,
    locationsHasLiveOffers,
    locationsEnabled
  } = {}, options
  /*: RequestOptions*/
  = {})
  /*: (Promise<PagedList<Business>>)*/
  {
    const _this11 = this;

    return _call(function () {
      const {
        propertyId
      } = _this11.context.serialize();

      let fieldsToFetch; // User-supplied fields are checked and used first, so that other field-related
      // arguments (fetchPlan, fetchLocations) can work as expected.
      //
      // Because fields cannot be cannot be extended as of today (see discussion
      // in offers-repo.list()), this CAN cause issues if the custom fields include
      // either `policies` or `locations` and the corresponding flag is set to
      // `true`. In these cases, the API will return an incorrect fields argument.

      if (options && options.fields) {
        fieldsToFetch = options.fields;
      } else {
        fieldsToFetch = businessId ? singleSearchFields : searchFields;
      }

      if (fetchPlan) {
        fieldsToFetch = [...fieldsToFetch, 'policies(plan(id,name))'];
      }

      if (fetchLocations) {
        fieldsToFetch = [...fieldsToFetch, 'locations(id,name)'];
      }

      if (!propertyId) {
        const params = {
          q: strinct(query),
          tagNames: strList(tags),
          planIds: strList(planIds),
          businessId,
          limit
        };
        const path = `/businesses/search`;
        const req = new _this11.client.Request(path, params, fieldsToFetch);
        req.parse = parse;
        return _await(_this11.client.get(req));
      }

      const params = {
        q: strinct(query),
        tagNames: strList(tags),
        planIds: strList(planIds),
        enabled,
        businessId,
        limit,
        hasLocations,
        locationsHasLiveOffers,
        locationsEnabled
      };
      const path = hasRoles ? `/self/properties/${propertyId}/businesses/search` : `/properties/${propertyId}/businesses/search`;
      const req = new _this11.client.Request(path, params, fieldsToFetch);
      req.parse = parse;
      return _await(_this11.client.get(req));
    });
  }

  listRaw() {
    const path = `/businesses`;
    const req = new this.client.Request(path, {}, rawListFields);
    req.parse = parse;
    return this.client.get(req);
  }

  create(instance
  /*: Business*/
  )
  /*: (Promise<Business>)*/
  {
    const _this12 = this;

    return _call(function () {
      const req = new _this12.client.Request(`/businesses`, instance, fields);
      req.serialize = serialize;
      return _await(_this12.client.post(req), function (newBusiness) {
        const newCatIds = _.map(instance.categories, c => c.id);

        const businessContext = _this12.context.clone({
          business: newBusiness.id
        });

        const categoriesRepo = new BusinessCategoriesRepo(_this12.client, businessContext);
        return _await(categoriesRepo.reconcile([], newCatIds), function () {
          // noinspection UnnecessaryLocalVariableJS
          return _await(_this12.for(newBusiness.id).updateSlug(instance.slug || instance.name), function (newSlug) {
            newBusiness.slug = newSlug;
            return newBusiness;
          });
        });
      });
    });
  }

  register({
    /*: { name: string, shortName: string }*/

    name,
    shortName
  })
  /*: Promise<Business>*/
  {
    const path = `/businesses/register`;
    const req = new this.client.Request(path, {
      name,
      shortName
    }, ['id', 'name', 'shortName']);
    req.parse = parse;
    return this.client.post(req);
  }

  reserveIdToken({
    /*: { meta: Object }*/

    meta
  })
  /*: Promise<{ id: string, token: string }>*/
  {
    const {
      propertyId
    } = this.context.serialize();
    const path = `/properties/${propertyId}/businesses/reservedIds`;
    const req = new this.client.Request(path, {
      meta
    }, ['id', 'token']);
    return this.client.post(req);
  }

  fromReservedIdToken({
    /*: {
        token: string, name: string, shortName: string
      }*/

    token,
    name,
    shortName
  })
  /*: Promise<Business>*/
  {
    const path = `/businesses/fromReservedIdToken`;
    const req = new this.client.Request(path, {
      token,
      name,
      shortName
    }, ['id', 'name', 'shortName']);
    req.parse = parse;
    return this.client.post(req);
  }

  selfSignupBusiness({
    /*: { token: string, name: string, shortName: string, skipReferralContextAttribution: boolean }*/

    token,
    name,
    shortName,
    skipReferralContextAttribution
  })
  /*: Promise<Business>*/
  {
    const _this13 = this;

    return _call(function () {
      const {
        propertyId
      } = _this13.context.serialize();

      if (!propertyId) throw new Error('Missing required context propertyId');
      return _await(token ? _this13.fromReservedIdToken({
        token,
        name,
        shortName
      }) : _this13.register({
        name,
        shortName
      }), function (business) {
        return _await(_this13.client.businesses.for(business.id).claim(), function () {
          return _await(_this13.client.properties.for(propertyId).businesses.for(business.id).claim({
            skipReferralContextAttribution
          }), function () {
            return business;
          });
        });
      });
    });
  }

}

module.exports = BusinessesRepo;